// Generated by ReScript, PLEASE EDIT WITH CARE

import * as S from "sury/src/S.res.mjs";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Sortable from "@dnd-kit/sortable";

var kindSchema = S.union([
      S.schema(function (s) {
            return {
                    TAG: "Punctuation",
                    placed: s.m(S.bool),
                    useValueForMarking: s.m(S.bool),
                    distractor: s.m(S.bool)
                  };
          }),
      S.literal("Character"),
      S.literal("CharacterEnd"),
      S.literal("PunctuationEnd")
    ]);

var itemSchema = S.schema(function (s) {
      return {
              id: s.m(S.string),
              text: s.m(S.string),
              kind: s.m(kindSchema)
            };
    });

var itemsSchema = S.array(itemSchema);

function splitItems(items) {
  return Belt_Array.reduce(items, [
              [],
              []
            ], (function (param, item) {
                var characters = param[1];
                var punctuation = param[0];
                var match = item.kind;
                if (typeof match !== "object") {
                  return [
                          punctuation,
                          Belt_Array.concat(characters, [item])
                        ];
                } else if (match.placed) {
                  return [
                          punctuation,
                          Belt_Array.concat(characters, [item])
                        ];
                } else {
                  return [
                          Belt_Array.concat(punctuation, [item]),
                          characters
                        ];
                }
              }));
}

function indexOf(xs, f) {
  return Belt_Array.reduceWithIndex(xs, -1, (function (acc, x, i) {
                if (acc === -1 && f(x)) {
                  return i;
                } else {
                  return acc;
                }
              }));
}

function dndMoveObject(xs, f, from, to) {
  var match = indexOf(xs, (function (node) {
          return f(from, node);
        }));
  var match$1 = indexOf(xs, (function (node) {
          return f(to, node);
        }));
  if (match > -1 && match$1 > -1) {
    return Sortable.arrayMove(xs, match, match$1);
  } else {
    return xs;
  }
}

function hasPunctuationAlready(items, drag, drop) {
  var currentDragItem = Belt_Array.getBy(items, (function (i) {
          return i.id === drag;
        }));
  if (currentDragItem === undefined) {
    return false;
  }
  var match = currentDragItem.kind;
  if (typeof match !== "object") {
    return false;
  }
  if (!match.useValueForMarking) {
    return false;
  }
  var text = currentDragItem.text;
  var id = currentDragItem.id;
  return Belt_Array.reduce(Belt_Array.reverse(items), [
                false,
                "",
                []
              ], (function (prevChar, item) {
                  if (item.id === id) {
                    var check = prevChar[2];
                    var charId = prevChar[1];
                    if (Belt_Array.some(check, (function (p) {
                              return p === text;
                            }))) {
                      return [
                              true,
                              charId,
                              []
                            ];
                    } else {
                      return [
                              prevChar[0],
                              charId,
                              check
                            ];
                    }
                  }
                  var match = item.kind;
                  if (prevChar[0]) {
                    return [
                            true,
                            prevChar[1],
                            []
                          ];
                  }
                  if (typeof match === "object" && match.placed && match.useValueForMarking) {
                    var check$1 = Belt_Array.concat(prevChar[2], [item.text]);
                    if ((prevChar[1] === drop || item.id === drop) && Belt_Array.some(check$1, (function (p) {
                              return p === text;
                            }))) {
                      return [
                              true,
                              "",
                              []
                            ];
                    } else {
                      return [
                              false,
                              item.id,
                              check$1
                            ];
                    }
                  }
                  return [
                          false,
                          item.id,
                          []
                        ];
                }))[0];
}

function sortItems(items, drag, drop) {
  var newItems = dndMoveObject(Belt_Array.map(items, (function (i) {
              if (i.id !== drag) {
                return i;
              }
              var match = i.kind;
              if (typeof match !== "object") {
                return i;
              } else {
                return {
                        id: i.id,
                        text: i.text,
                        kind: {
                          TAG: "Punctuation",
                          placed: true,
                          useValueForMarking: match.useValueForMarking,
                          distractor: match.distractor
                        }
                      };
              }
            })), (function (id, node) {
          return node.id === id;
        }), drag, drop);
  if (hasPunctuationAlready(newItems, drag, drop)) {
    return items;
  } else {
    return newItems;
  }
}

function removeItem(items, drag) {
  var end = items[items.length - 2 | 0];
  return dndMoveObject(Belt_Array.map(items, (function (i) {
                    if (i.id !== drag) {
                      return i;
                    }
                    var match = i.kind;
                    if (typeof match !== "object") {
                      return i;
                    } else {
                      return {
                              id: i.id,
                              text: i.text,
                              kind: {
                                TAG: "Punctuation",
                                placed: false,
                                useValueForMarking: match.useValueForMarking,
                                distractor: match.distractor
                              }
                            };
                    }
                  })), (function (id, node) {
                return node.id === id;
              }), drag, end.id);
}

export {
  kindSchema ,
  itemSchema ,
  itemsSchema ,
  splitItems ,
  indexOf ,
  dndMoveObject ,
  hasPunctuationAlready ,
  sortItems ,
  removeItem ,
}
/* kindSchema Not a pure module */
